
import { defineComponent, reactive, toRaw } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// validations
import { CompaniesSetPasswordValidation } from '@/modules/CompaniesModule/validations/CompaniesActions.validation'
import useVuelidate from '@vuelidate/core'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'reset'],
    setup(_, { emit }) {
        const state = reactive({
            password: null as string | null,
        })

        const state_form$ = useVuelidate(CompaniesSetPasswordValidation, state)

        const emitCancel = () => {
            emit('cancel')
        }

        const emitReset = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('reset', state.password)
        }

        return { state, state_form$, emitCancel, emitReset }
    },
})
